// removed by extract-text-webpack-plugin
module.exports = {"shareTools":"_3ayUrsBF7o38i9lEe1ZZ1-","shareTool":"_3kiQOZWRhdISXYSslTK6Fv","twitter":"_3Fc48HgcpdASUadtA9jaVj","facebook":"_3mw8nuOHhflcr62WhrTDe","link":"ADJuwbRPDFU5LKbkjNc60"};


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/scss/components/share-tools.scss
// module id = 252
// module chunks = 0